// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "144ad0fa8cfbdc201ae0" + ".chunk.js";
};